// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spin from 'antd/lib/spin';
import Empty from 'antd/lib/empty';

import { getLabelingRunsAsync } from 'actions/labeling-runs-actions';
import { CombinedState } from 'reducers';

import TopBarComponent from './top-bar';
import RunListComponent from './run-list';

export default function LabelingRunsPage(): JSX.Element {
    const dispatch = useDispatch();
    const fetching = useSelector((state: CombinedState) => state.labelingRuns.fetching);
    const count = useSelector((state: CombinedState) => state.labelingRuns.current.length);

    useEffect(() => {
        dispatch(getLabelingRunsAsync());
    }, []);

    return (
        <div className='cvat-labeling-runs-page' style={{ paddingTop: 16, height: '100%', overflow: 'auto' }}>
            <TopBarComponent />
            {fetching ? (
                <div className='cvat-empty-project-list'>
                    <Spin size='large' className='cvat-spinner' />
                </div>
            ) : (
                count ? <RunListComponent /> : (
                    <Empty
                        className='cvat-empty-labeling-runs-list'
                        description='No labeling runs found'
                    />
                )
            )}
        </div>
    );
}
